import * as booking_update from '../data/booking/booking.scenarios.update.svelte.js';
import * as booking_update_export from '../data/booking/booking.scenarios.select.export.svelte.js';
import * as products_select from '../data/products/products.scenarios.select.svelte.js';
import * as packagedeals_select from '../data/packagedeals/packagedeals.scenarios.select.svelte.js';
import * as money_util from "./MoneyUtil.js";
import {progress} from '../data/progress/feature.progress.svelte.js';
import {booking} from '../data/booking/feature.booking.svelte.js';
import {booker} from '../data/booker/feature.booker.svelte.js';

// import BookingUpdatersReceipt from "../features/booking/BookingUpdatersReceipt";

class DataLayerUtil {
  static bDebug = false;
  // static bDebug = true;

  static getGlobalTagManagerDebugMode = () => {
    return false;
  }

  static logGoToStep = (sStepID = '') => {
    sStepID = sStepID + '';
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();
    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //   event: 'funnelStep',
    //   funnelStep: `booking-flow step ${sStepID}`
    // });

    var sEvent = "funnel_step";

    switch ( sStepID )
    {
      case '20':
        sEvent += "_goto_calendar";
        break;
      case '30':
        sEvent += "_goto_time";
        break;
      case '40':
        sEvent += "_goto_package_options";
        break;
      case '50':
        sEvent += "_goto_treatments";
        break;
      case '60':
        sEvent += "_goto_form";
        break;
      case '70': // deze heeft ook zijn eigen event
        sEvent += "_goto_payment_info";
        break;
      case '80': // deze heeft ook zijn eigen event
        sEvent += "_goto_submit";
        break;
    }

    const oEvent = {
      event: sEvent,
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        funnel_step: `booking-flow step ${sStepID}`
      }
    };

    gtag("event", "funnel_step", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('dl', sStepID, sEvent);
  };


  static eventStartReservation = () => {
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    const oEvent = {
      event: "start_reservation",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {}
    };

    gtag("event", "start_reservation", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event start_reservation', oEvent);
  };

  static bForceSetLoggedInTrue = false;
  static eventLoggedIn = (mState) => {
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    var iCurrentStep = progress.iCurrentVisibleStep;

    var sMethod = 'login_start_reservation';

    if ( iCurrentStep > 10 )
    {
      sMethod = 'login_end_reservation';
    }

    const oEvent = {
      event: "login",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        method: sMethod
      }
    };

    gtag("event", "login", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event login', oEvent);

    // BONUS - ook nog een custom event
    const oCustomEvent = {
      event: sMethod,
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {}
    };

    gtag("event", sMethod, oCustomEvent);
    dataLayer.push(oCustomEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event ' + sMethod, oCustomEvent);
  };

  static eventSkipLogIn = (mState) => {
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    const oEvent = {
      event: "login",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        method: 'skip_login_reservation'
      }
    };

    gtag("event", "login", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event login', oEvent);

    // BONUS - ook nog een custom event
    const oCustomEvent = {
      event: 'skip_login_reservation',
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {}
    };

    gtag("event", 'skip_login_reservation', oCustomEvent);
    dataLayer.push(oCustomEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event skip_login_reservation', oCustomEvent);
  };

  static eventSelectPackageDeal = (mState, iPackageDealID) => {
    // SelectItem alias
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#select_item
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    var sSignedInStatus = DataLayerUtil.getStatusSignedIn(mState);

    let aItems = [];
    aItems.push(DataLayerUtil.getGTagItemConfigForPackageDeal(mState, iPackageDealID));

    const oEvent = {
      event: "select_item",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        sign_in_status: sSignedInStatus,
        items: aItems
      }
    };

    gtag("event", "select_item", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event select_item', oEvent);

    DataLayerUtil.eventDebug(mState);
  };

  static getGTagItemConfigForPackageDeal = (mState, iPackageDealID, iQuantity = 1) => {
    let nPrice = 0;
    let sName = '';

    const mPackageDeal = packagedeals_select.getPackageDealByID(mState, iPackageDealID);

    if ( mPackageDeal )
    {
      const mExtraPackageDealInfoLastFetchedDate = packagedeals_select.getPackageDealInfoForLastProcessedDate(mState, iPackageDealID);
      let sDateUsedForPackageDealInfo = false;

      if ( mExtraPackageDealInfoLastFetchedDate )
      {
        sDateUsedForPackageDealInfo = mExtraPackageDealInfoLastFetchedDate.sDateUsed;
      }

      if ( !sDateUsedForPackageDealInfo || sDateUsedForPackageDealInfo !== booking.sArrivalDate )
      {
        // niet goed
      }
      else
      {
        nPrice = parseFloat(money_util.centsToString(mExtraPackageDealInfoLastFetchedDate.iPrice, '.'));
      }

      sName = mPackageDeal.sTitle;
    }

    return {
      item_id: "col_" + iPackageDealID,
      item_name: sName,
      // index: 0,
      currency: "EUR",
      price: nPrice,
      quantity: 1
    };
  };

  static getStatusSignedIn = (mState) => {

    if ( DataLayerUtil.bForceSetLoggedInTrue === true )
    {
      return 'signed_in';
    }

    var bIsSignedIn = booker.iCustomerID;
    var sSignedInStatus = 'signed_out';

    if ( bIsSignedIn === true )
    {
      sSignedInStatus = 'signed_in';
    }

    //console.log('ingelogde status is ', sSignedInStatus, mState.getIn(['booker', 'iCustomerID'], 0));
    return sSignedInStatus;
  };

  static eventSelectProductInPackageDeal = (mState, iProductID, iPackageDealID) => {
    // SelectItem alias
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#select_item
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    var sSignedInStatus = DataLayerUtil.getStatusSignedIn(mState);

    var aItems = [];
    aItems.push(DataLayerUtil.getGTagItemConfigForProductInPackageDeal(mState, iProductID, iPackageDealID));

    const oEvent = {
      event: "select_item",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        sign_in_status: sSignedInStatus,
        items: aItems
      }
    };

    gtag("event", "select_item", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event select_item', oEvent);

    DataLayerUtil.eventDebug(mState);
  };

  static getGTagItemConfigForProductInPackageDeal = (mState, iProductID, iPackageDealID, iQuantity = 1) => {
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#select_item

    var sName = '';
    var nPrice = 0;

    if ( iPackageDealID )
    {
      let mProductInPackageDeal = packagedeals_select.getProductInPackageDeal(mState, iPackageDealID, iProductID);

      if ( mProductInPackageDeal )
      {
        nPrice = parseFloat(money_util.centsToString(mProductInPackageDeal.iAdditionalCosts, '.'));
      }
    }

    const mProduct = products_select.getProductByID(mState, iProductID);
    if ( mProduct )
    {
      sName = mProduct.sTitle;
    }

    return {
      item_id: "prod_" + iProductID,
      item_name: sName,
      //index: 0,
      currency: "EUR",
      price: nPrice,
      quantity: iQuantity
    };
  };

  static getGTAG = () => {
    if ( typeof window.gtag !== "undefined" )
    {
      return window.gtag;
    }

    return (oTest1, oTest2, oTest3) => {
      //console.log('gTag debug', oTest1, oTest2, oTest3);
    }
  }

  static getDataLayer = () => {
    if ( typeof window.dataLayer !== "undefined" )
    {
      return window.dataLayer;
    }

    return {
      push: (oTest1) => {
        //console.log('dataLayer debug', oTest1);
      }
    }
  }

  static eventSelectProduct = (mState, iProductID) => {
    // SelectItem alias
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#select_item
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    var sSignedInStatus = DataLayerUtil.getStatusSignedIn(mState);

    let aItems = [];
    aItems.push(DataLayerUtil.getGTagItemConfigForProduct(mState, iProductID));

    const oEvent = {
      event: "select_item",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        sign_in_status: sSignedInStatus,
        items: aItems
      }
    };

    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event select_item', oEvent);

    // temp - mag weer weg
    //console.log('test1392', DataLayerUtil.getGTagItemsForWholeBooking(mState));

    DataLayerUtil.eventDebug(mState);
  };

  static getGTagItemConfigForProduct = (mState, iProductID, iQuantity = 1) => {
    // SelectItem alias
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#select_item

    var sName = '';
    var nPrice = '';

    var mProduct = products_select.getProductByID(mState, iProductID);

    if ( mProduct )
    {
      sName = mProduct.sTitle;
      nPrice = parseFloat(money_util.centsToString(mProduct.iPrice, '.'));
    }

    return {
      item_id: "prod_" + iProductID,
      item_name: sName,
      //index: 0,
      currency: "EUR",
      price: nPrice,
      quantity: iQuantity
    }
  };


  static eventAddPaymentInfo = (mState) => {
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#add_payment_info
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    var sSignedInStatus = DataLayerUtil.getStatusSignedIn(mState);

    const iTotal = booking.mTotals.mTotal.iCents;

    const oEvent = {
      event: "add_payment_info",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        sign_in_status: sSignedInStatus,
        items: DataLayerUtil.getGTagItemsForWholeBooking(mState),
        currency: "EUR",
        value: parseFloat(money_util.centsToString(iTotal, '.'))
      }
    };

    gtag("event", "add_payment_info", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event add_payment_info', oEvent);

    DataLayerUtil.eventDebug(mState);
  };

  static eventBeginCheckout = (mState) => {
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#begin_checkout
    var gtag = DataLayerUtil.getGTAG();
    var dataLayer = DataLayerUtil.getDataLayer();

    var sSignedInStatus = DataLayerUtil.getStatusSignedIn(mState);

    const iTotal = booking.mTotals.mTotal.iCents;

    const oEvent = {
      event: "begin_checkout",
      debug_mode: DataLayerUtil.getGlobalTagManagerDebugMode(),
      ecommerce: {
        sign_in_status: sSignedInStatus,
        items: DataLayerUtil.getGTagItemsForWholeBooking(mState),
        currency: "EUR",
        value: parseFloat(money_util.centsToString(iTotal, '.'))
      }
    };

    gtag("event", "begin_checkout", oEvent);
    dataLayer.push(oEvent);

    if ( DataLayerUtil.bDebug ) console.log('gtag event begin_checkout', oEvent);
  };

  static eventDebug = (mState) => {

    if ( 1 === 2 )
    {
      // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=7579307741863579967-EU&client_type=gtag#begin_checkout
      var gtag = DataLayerUtil.getGTAG();
      var dataLayer = DataLayerUtil.getDataLayer();

      var sSignedInStatus = DataLayerUtil.getStatusSignedIn(mState);

      const iTotal = booking.mTotals.mTotal.iCents;

      const oEvent = {
        sign_in_status: sSignedInStatus,
        items: DataLayerUtil.getGTagItemsForWholeBooking(mState),
        currency: "EUR",
        value: parseFloat(money_util.centsToString(iTotal, '.'))
      };

      if ( DataLayerUtil.bDebug ) console.log('gtag event debug_begin_checkout', oEvent);
    }
  };

  static getGTagItemsForWholeBooking = () => {
    let aProductsOutsidePackage = [];
    let aPackagesWithTheirProducts = [];

    let aItems = [];

    const oBooking = booking_update_export.getBookingExport();
    let iBookedPackageDealID = false;

    for ( const oPerson of oBooking.aPeople )
    {
      for ( const iPackageDealID of oPerson.arrangements ) // de naam 'arrangements' is hier omdat het hier in lijn moet zijn met backend
      {
        iBookedPackageDealID = iPackageDealID;
        const mPackageDeal = packagedeals_select.getPackageDealByID(iPackageDealID);

        if ( mPackageDeal )
        {
          const mExtraPackageDealInfoLastFetchedDate = packagedeals_select.getPackageDealInfoForLastProcessedDate(iPackageDealID);
          let sDateUsedForPackageDealInfo = false;
          if ( mExtraPackageDealInfoLastFetchedDate ) sDateUsedForPackageDealInfo = mExtraPackageDealInfoLastFetchedDate.sDateUsed;
          if ( !sDateUsedForPackageDealInfo || sDateUsedForPackageDealInfo !== booking.sArrivalDate ) // "2018-07-03" - "29-07-2018"
          {
            aPackagesWithTheirProducts = DataLayerUtil.addPackageDealToGTAGConfig(aPackagesWithTheirProducts, iPackageDealID);
          }
        }
      }

      // producten in arrangement
      for ( const iBuyableID of oPerson.allProducts )
      {
        if ( oPerson.productsWithoutArr.indexOf(iBuyableID) === -1 )
        {   // dit is een product dat onderdeel is van een arrangement
          if ( iBookedPackageDealID )
          {
            let mProductInPackageDeal = packagedeals_select.getProductInPackageDeal(iBookedPackageDealID, iBuyableID);
            if ( mProductInPackageDeal )
            {
              aPackagesWithTheirProducts = DataLayerUtil.addProductToGTAGPackageDealsConfig(aPackagesWithTheirProducts, iBookedPackageDealID, iBuyableID);
            }
          }
        }
        else
        { // dit is een product buiten een arrangement
          const mProduct = products_select.getProductByID(mState, iBuyableID);

          if ( mProduct )
          {
            aProductsOutsidePackage = DataLayerUtil.addProductToGTAGProductsConfig(aProductsOutsidePackage, iBuyableID);
          }
        }
      }
    } // eof aPeople

    //console.log('GTAG - aPackagesWithTheirProducts', JSON.stringify(aPackagesWithTheirProducts));
    //console.log('GTAG - aProductsOutsidePackage', JSON.stringify(aProductsOutsidePackage));

    for ( const oPackageDealConfig of aPackagesWithTheirProducts )
    {
      aItems.push(DataLayerUtil.getGTagItemConfigForPackageDeal(oPackageDealConfig.iPackageDealID, oPackageDealConfig.iQuantity));

      for ( const oProductInPackageDealConfig of oPackageDealConfig.aSelectedProducts )
      {
        aItems.push(DataLayerUtil.getGTagItemConfigForProductInPackageDeal(oProductInPackageDealConfig.iProductID, oPackageDealConfig.iPackageDealID, oProductInPackageDealConfig.iQuantity));
      }
    }

    //console.log('GTAG - aProductsOutsidePackage', JSON.stringify(aProductsOutsidePackage));
    //console.log('GTAG - aItems voor toevoegen losse producten', JSON.stringify(aItems));

    for ( const oProductConfig of aProductsOutsidePackage )
    {
      aItems.push(DataLayerUtil.getGTagItemConfigForProduct(oProductConfig.iProductID, oProductConfig.iQuantity));
    }

    //console.log('GTAG - Processed', JSON.stringify(aItems));
    return aItems;
  };

  static addProductToGTAGPackageDealsConfig = (aPackageDealsAndProducts, iPackageDealID, iProductID, iQuantity = 1) => {
    // Find the package deal by iPackageDealID
    let oPackageDealConfig = aPackageDealsAndProducts.find(oTempPackageDealConfig => oTempPackageDealConfig.iPackageDealID === iPackageDealID);

    if ( oPackageDealConfig )
    {
      // If package deal is found, add the product to the aSelectedProducts array
      let aProductConfig = oPackageDealConfig.aSelectedProducts.find(oTempProductConfig => oTempProductConfig.iProductID === iProductID);

      if ( aProductConfig )
      {
        // If product is found, increase the quantity
        aProductConfig.iQuantity += iQuantity;
      }
      else
      {
        // If product is not found, add the product to the aSelectedProducts array
        oPackageDealConfig.aSelectedProducts.push({
          iProductID: iProductID,
          iQuantity: iQuantity
        });
      }
    }
    else
    {
      // Als arrangement niet is gevonden dan toevoegen.
      // Dit is een vangnet want normaal gaat dit via addPackageDealToGTAGConfig
      aPackageDealsAndProducts.push({
        iPackageDealID: iPackageDealID,
        iQuantity: 1,
        aSelectedProducts: [
          {
            iProductID: iProductID,
            iQuantity: iQuantity
          }
        ]
      });
    }

    return aPackageDealsAndProducts;
  }

  static addPackageDealToGTAGConfig = (aPackageDealsAndProducts, iPackageDealID, iQuantity = 1) => {
    // Find the package deal by iPackageDealID
    let oPackageDealConfig = aPackageDealsAndProducts.find(oTempPackageDealConfig => oTempPackageDealConfig.iPackageDealID === iPackageDealID);

    if ( oPackageDealConfig )
    {
      oPackageDealConfig.iQuantity += iQuantity;
    }
    else
    {
      // Arrangement toevoegen
      aPackageDealsAndProducts.push({
        iPackageDealID: iPackageDealID,
        iQuantity: iQuantity,
        aSelectedProducts: []
      });
    }

    return aPackageDealsAndProducts;
  }

  static addProductToGTAGProductsConfig = (aProducts, iProductID, iQuantity = 1) => {
    let oProductConfig = aProducts.find(oTempProductConfig => oTempProductConfig.iProductID === iProductID);

    if ( oProductConfig )
    {
      oProductConfig.iQuantity += iQuantity;
    }
    else
    {
      aProducts.push(
        {
          iProductID: iProductID,
          iQuantity: iQuantity
        });
    }

    return aProducts;
  }

}

export default DataLayerUtil;